import React, { useEffect, useState } from "react";
import { decodeToken } from "react-jwt";
import { Navigate, useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import DuplicateLoginErrorComponent from "../../components/DuplicateLoginErrorComponent";
import LoadingBeforeRedirect from "../../components/LoadingBeforeRedirect";
import { useDispatch, useSelector } from "react-redux";
import { getGradeUserInfo } from "../../reducers/gradesSlice";
import ConstantStrings from "../../constants/ConstantStrings";

const cookies = new Cookies();
const roles = ["CREATOR", "REVIEWER"];

const PrivateRouter = ({ page, children }) => {
  const token = cookies.get("signinUser") || cookies.get("register");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { listUserInfo } = useSelector((state) => state.grades);
  const [showError, setShowError] = useState(false);

  const arrayPath = [
    "/account",
    "/profile",
    "/upgrade",
    "/list-unit",
    "/exercise",
    "/activities",
    "/achievement",
    "/",
  ];

  const redirectToLanding = () => {
    window.location.href =
      process.env.REACT_APP_ENV === "development"
        ? process.env.REACT_APP_DEV_LANDING_PAGE_URL
        : process.env.REACT_APP_LANDING_PAGE_URL;
  };

  const getUserInformation = async () => {
    if (listUserInfo) return listUserInfo;
    try {
      const resultAction = await dispatch(getGradeUserInfo());
      return resultAction.payload;
    } catch (error) {
      if (error?.response?.status === 409) {
        localStorage.setItem("clearAll", true);
        setShowError(true);
      }
      throw error;
    }
  };

  const clearCookiesAndRedirect = () => {
    const allCookies = cookies.getAll();
    Object.keys(allCookies).forEach((key) => cookies.remove(key));
    arrayPath.forEach((path) => cookies.remove("signinUser", { path }));
    redirectToLanding();
  };

  useEffect(() => {
    const validateAccess = async () => {
      if (page === "PRIVATE") {
        if (!token && window.location.pathname !== "/payment-success") {
          return;
        }
        const decode = decodeToken(token);
        const emailValidated = decode?.emailValidated;
        try {
          const userInfo = await getUserInformation();

          if (!decode.roles || !decode.roles?.includes("USER")) {
            clearCookiesAndRedirect();
          } else {
            if ((emailValidated=== false && userInfo.email ==="")&&(!userInfo?.phone || userInfo?.phone === "" || userInfo?.phone === null) && !window.location.pathname.includes("validate-phone")) {
              return navigate("/validate-phone");
            }
            if (
              (userInfo?.fullName === "" || userInfo?.birthday === "" || userInfo?.gradeId === null || userInfo?.gradeId === "" || userInfo?.gradeName === "") &&
              !window.location.pathname.includes("calibration")
            ) {
              return navigate("/calibration");
            }
          }
        } catch {}
      } else if (page === "VALIDATE_PHONE") {
        try {
          const userInfo = await getUserInformation();
          if (userInfo?.phone !== "" && userInfo?.phone !== null && userInfo?.phone?.length > 0) navigate("/");
        } catch {}
      } else if (page === "REQUIRE_LOGIN" && !token) {
        // alert("Phai dang nhap");
        redirectToLanding();
      } else if (page === "ADMIN") {
        const arrayURL = JSON.parse(
          process.env.REACT_APP_ENV === "development"
            ? process.env.REACT_APP_DEV_ARRAY_ADMIN_URL
            : process.env.REACT_APP_ARRAY_ADMIN_URL
        );
        const handleRes = (e) => {
          if (arrayURL.some((url) => e.origin.includes(url))) {
            const decoded = decodeToken(e?.data.token);
            if (!decoded?.roles?.some((role) => roles.includes(role))) {
              alert("Khong duoc vao");
              navigate("/");
            }
          }
        };
        window.addEventListener("message", handleRes);
        return () => window.removeEventListener("message", handleRes);
      } else if (page === "IKMC-EXAM-QUESTION" && !localStorage.getItem("nameExam")) {
        window.location.href = "https://kurio.vn/";
      } else if (page === "MONTHLY-EXAM-QUESTION") {
        // const previousRouter = location.state?.prevRouter;
        // console.log(location);
        // if (localStorage.getItem("")) {
        // //   window.location.href = "https://kurio.vn/";
        // }
      }
      if (page === "BLOCK_ROUTER") {
        getUserInformation()
          .then((res) => {
            if (ConstantStrings.GRADE_ID_HIDES.includes(res.gradeId)) {
              navigate("/");
            }
          })
          .catch((error) => {
            if (error?.response?.status === 409) {
              localStorage.setItem("clearAll", true);
              setShowError(true);
              return <DuplicateLoginErrorComponent isShowPopup={true} />;
            }
          });
      }
    };

    validateAccess();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, token]);

  if (page === "LOGIN" && token) {
    return <Navigate to="/" />;
  }

  if (page === "PRIVATE" && !token && window.location.pathname !== "/payment-success") {
    return <LoadingBeforeRedirect />;
  }

  return showError ? <DuplicateLoginErrorComponent isShowPopup={true} /> : children;
};

export default PrivateRouter;